<template>
  <span v-if="onlyDot" v-b-tooltip.hover :title="text" class="dot ml-2" :style="{ backgroundColor: dotColor }"></span>
  <span v-else class="status" :class="{ bg: enableBg }">
    <span class="dot" :style="{ backgroundColor: dotColor }"></span>
    <span>{{ text }}</span>
  </span>
</template>

<script>
export default {
  props: ["status", "onlyDot", "enableBg"],
  computed: {
    dotColor() {
      let bgClass = "gray";
      if (this.status == "REVIEW") {
        bgClass = "gray";
      } else if (this.status == "PRE_TEST") {
        bgClass = "#2998FF";
      } else if (this.status == "TEST") {
        bgClass = "orange";
      } else if (this.status == "PRE_PROD") {
        bgClass = "#9440FF";
      } else if (this.status == "PROD") {
        bgClass = "#2ECD06";
      } else if (this.status == "CANCELED") {
        bgClass = "red";
      }
      return bgClass;
    },
    text() {
      if (this.status == "REVIEW") {
        return this.$t("firm.status.review");
      } else if (this.status == "PRE_TEST") {
        return this.$t("firm.status.pre-test");
      } else if (this.status == "TEST") {
        return this.$t("firm.status.test");
      } else if (this.status == "PRE_PROD") {
        return this.$t("firm.status.pre-prod");
      } else if (this.status == "PROD") {
        return this.$t("firm.status.prod");
      } else if (this.status == "CANCELED") {
        return this.$t("firm.status.canceled");
      } else {
        return this.$t("firm.status.review");
      }
    },
  },
};
</script>
<style scoped>
.status {
  font-weight: bold;
  padding: 5px 10px;
  border-radius: 7px;
  min-width: 100px;
}
.bg {
  background-color: rgb(233 233 233);
}
</style>
